/*
  Add to cart spinner.

  Neither add to cart path on this store runs the theme's own product-form
  submit handler, so Dawn's built in spinner markup never fires. There are
  two paths, confirmed by instrumentation on 31 July 2026:

    1. AMP Slide Cart Drawer owns the add. The submit click reaches document
       in the capture phase, and the drawer opens roughly 500 to 800ms later.

    2. Easify Product Options owns the add whenever it has a second line item
       to contribute, for example a frame. It swallows the submit click before
       document sees it, sets the disabled attribute on the button for the
       duration of the add, then AMP opens the drawer 15 to 35ms after the
       attribute clears.

  This drives the existing .loading__spinner markup from whichever signal
  arrives first, and clears it when the cart drawer appears.

  Remove this file if the theme ever regains ownership of add to cart, since
  assets/product-form.js already does the same job on its own submit path.
*/
(function () {
  if (window.__vsAddToCartSpinner) return;
  window.__vsAddToCartSpinner = true;

  var BUTTON_SELECTOR = '.product-form__submit';
  var SAFETY_MS = 6000; /* a button must never be left spinning */
  var GRACE_MS = 750; /* how long to wait for the drawer once disabled clears */

  var active = null;

  function bodyLocked() {
    var style = document.body.getAttribute('style') || '';
    return style.indexOf('overflow: hidden') > -1 || style.indexOf('overflow:hidden') > -1;
  }

  /*
    Dawn also toggles disabled on this button when the shopper picks a sold out
    or unavailable variant, which has nothing to do with an add in progress.
    Those states relabel the button, so the label is a reliable discriminator.
  */
  function isAddAction(button) {
    var strings = window.variantStrings || {};
    var label = button.textContent ? button.textContent.trim() : '';
    if (!label) return true;
    if (strings.soldOut && label.indexOf(strings.soldOut) > -1) return false;
    if (strings.unavailable && label.indexOf(strings.unavailable) > -1) return false;
    return true;
  }

  function stop() {
    if (!active) return;
    clearTimeout(active.safety);
    clearTimeout(active.grace);
    active.observer.disconnect();
    active.button.classList.remove('loading');
    active.spinner.classList.add('hidden');
    active = null;
  }

  function start(button) {
    if (active || !button) return;

    var spinner = button.querySelector('.loading__spinner');
    if (!spinner) return;

    button.classList.add('loading');
    spinner.classList.remove('hidden');

    /*
      The drawer announces itself by locking body scroll. Only a transition
      into that state counts, so a drawer that was already open cannot end
      the spin before it has begun.
    */
    var wasLocked = bodyLocked();
    var observer = new MutationObserver(function () {
      if (!wasLocked && bodyLocked()) stop();
    });
    observer.observe(document.body, { attributes: true, attributeFilter: ['style'] });

    active = {
      button: button,
      spinner: spinner,
      observer: observer,
      grace: null,
      safety: setTimeout(stop, SAFETY_MS)
    };
  }

  /* Path 1. The click reaches us, so there is no perceptible delay. */
  document.addEventListener(
    'click',
    function (event) {
      var target = event.target;
      if (!target || !target.closest) return;

      var button = target.closest(BUTTON_SELECTOR);
      if (!button || button.disabled) return;

      start(button);
    },
    true
  );

  /* Path 2. The click is swallowed, so follow the disabled attribute instead. */
  var scope = document.querySelector('.product__info-container') || document.body;

  new MutationObserver(function (records) {
    for (var i = 0; i < records.length; i++) {
      var element = records[i].target;
      if (!element.matches || !element.matches(BUTTON_SELECTOR)) continue;

      if (element.disabled) {
        if (isAddAction(element)) start(element);
      } else if (active && active.button === element && !active.grace) {
        active.grace = setTimeout(stop, GRACE_MS);
      }
    }
  }).observe(scope, { attributes: true, attributeFilter: ['disabled'], subtree: true });

  /* Restored from the back/forward cache, a button could be left mid spin. */
  window.addEventListener('pageshow', function () {
    stop();
  });
})();
